var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrintColorWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7743_69939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 14.1672H15.8333C16.2754 14.1672 16.6993 13.9916 17.0118 13.679C17.3244 13.3664 17.5 12.9425 17.5 12.5005V9.16715C17.5 8.72513 17.3244 8.3012 17.0118 7.98864C16.6993 7.67608 16.2754 7.50049 15.8333 7.50049H4.16667C3.72464 7.50049 3.30072 7.67608 2.98816 7.98864C2.67559 8.3012 2.5 8.72513 2.5 9.16715V12.5005C2.5 12.9425 2.67559 13.3664 2.98816 13.679C3.30072 13.9916 3.72464 14.1672 4.16667 14.1672H5.83333",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 7.50049V4.16715C14.1668 3.72513 13.9912 3.3012 13.6787 2.98864C13.3661 2.67608 12.9422 2.50049 12.5002 2.50049H7.50016C7.05814 2.50049 6.63421 2.67608 6.32165 2.98864C6.00909 3.3012 5.8335 3.72513 5.8335 4.16715V7.50049",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 12.5007C5.8335 12.0586 6.00909 11.6347 6.32165 11.3221C6.63421 11.0096 7.05814 10.834 7.50016 10.834H12.5002C12.9422 10.834 13.3661 11.0096 13.6787 11.3221C13.9912 11.6347 14.1668 12.0586 14.1668 12.5007V15.834C14.1668 16.276 13.9912 16.6999 13.6787 17.0125C13.3661 17.3251 12.9422 17.5007 12.5002 17.5007H7.50016C7.05814 17.5007 6.63421 17.3251 6.32165 17.0125C6.00909 16.6999 5.8335 16.276 5.8335 15.834V12.5007Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7743_69939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.000488281)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintColorWhite);
export default __webpack_public_path__ + "static/media/print-color-white.e37945f90a24a2758f060a20a0517b27.svg";
export { ForwardRef as ReactComponent };